import React from 'react';
import { Star } from 'lucide-react';
import { useContent } from '../context/ContentContext';

const Testimonials = () => {
  const { content } = useContent();
  const testimonials = content.testimonials;

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <p className="text-sm font-semibold text-[#0e9f6e] mb-3">Loved by sellers</p>
          <h2 className="font-display text-4xl sm:text-5xl font-700 text-[#0f1712]">Trusted across all 50 states.</h2>
          <p className="text-[#0f1712]/55 mt-4">Helping thousands of solo makers, vendors and small businesses get paid faster.</p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {testimonials.map((t, i) => (
            <div key={i} className="break-inside-avoid mb-5 rounded-3xl bg-[#f6f6f2] border border-[#0f1712]/8 p-7">
              <div className="flex gap-0.5 mb-4">
                {[1,2,3,4,5].map((s) => <Star key={s} size={14} className="fill-[#0e9f6e] text-[#0e9f6e]" />)}
              </div>
              <p className="text-[#0f1712] text-[15px] leading-relaxed">“{t.text}”</p>
              <div className="flex items-center gap-3 mt-5">
                <div className="w-9 h-9 rounded-full bg-[#0e9f6e]/15 flex items-center justify-center font-display font-700 text-[#0e9f6e] text-sm">
                  {(t.name || '?').charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0f1712] leading-tight">{t.name}</p>
                  <p className="text-xs text-[#0f1712]/45">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
